<template>
  
  <v-data-table
    dense
    v-resize="onResize"
    id="time__table"
    fixed-header
    :items-per-page="-1" 
    :footer-props="{ itemsPerPageOptions: [-1] }"
    :headers="headers"
    :items="items"
    height="300px"
    :sort-by="tablesortBy"
    :sort-desc="tablesortDesc"
    no-data-text="측정된 자료가 없습니다."
    class="table_content"
    item-key="date"
    single-select
    hide-default-header
    hide-default-footer
  >
    <template v-slot:header>
      <thead v-if="!isMobile">
        <tr>
          <th rowspan="2" @click="toggleSort('date')" class="text-center">발급일자</th>
          <th rowspan="2" class="text-center">개체</th>

          <th colspan="6" class="text-center">육질등급</th>
          <th colspan="3" class="text-center">육량등급</th>
          <th colspan="2" class="text-center">평균 도체중</th>
          <th colspan="4" class="text-center">성별</th>

          <th rowspan="2">계</th>
        </tr>
        <tr style="position:sticky; top:40px; z-index: 10;">
          <th>1++</th>
          <th>1+</th>
          <th>1</th>
          <th>2</th>
          <th>3</th>
          <th>등외</th>
          
          <th>A</th>
          <th>B</th>
          <th>C</th>
          <!-- <th>등외</th> -->

          <th>등급</th>
          <th>등외</th>

          <th>암</th>
          <th>수</th>
          <th>거세</th>
          <th>프리마틴</th>
        </tr>
      </thead>
    </template>

    <template v-slot:item="{ item }">
      <tr v-if="!isMobile">
        <td class="table_line">{{ item.date }}</td>
        <td class="table_line detail"  @click="$emit('detailInfo', item.date)">
          <v-icon size="24" color="black">
            mdi-file-document
          </v-icon>
        </td>

        <td v-text="item.cnt_qgrade['1++'] === 0 ? '' : item.cnt_qgrade['1++']"></td>
        <td v-text="item.cnt_qgrade['1+'] === 0 ? '' : item.cnt_qgrade['1+']"></td>
        <td v-text="item.cnt_qgrade['1'] === 0 ? '' : item.cnt_qgrade['1']"></td>
        <td v-text="item.cnt_qgrade['2'] === 0 ? '' : item.cnt_qgrade['2']"></td>
        <td v-text="item.cnt_qgrade['3'] === 0 ? '' : item.cnt_qgrade['3']"></td>
        <td class="table_line" v-text="item.cnt_qgrade['etc'] === 0 ? '' : item.cnt_qgrade['etc']"></td>

        <td v-text="item.cnt_wgrade['A'] === 0 ? '' : item.cnt_wgrade['A']"></td>
        <td v-text="item.cnt_wgrade['B'] === 0 ? '' : item.cnt_wgrade['B']"></td>
        <td class="table_line" v-text="item.cnt_wgrade['C'] === 0 ? '' : item.cnt_wgrade['C']"></td>
        <!-- <td class="table_line" v-text="item.cnt_wgrade['D'] === 0 ? '' : item.cnt_wgrade['D']"></td> -->

        <td v-text="item['kg+'].ave == 0 ? '' : item['kg+'].ave"></td>
        <td class="table_line" v-text="item['kg-'].ave == 0 ? '' : item['kg-'].ave"></td>

        <td class="text-align" v-text="item.cnt_sex['female'] === 0 ? '' : item.cnt_sex['female']"></td>
        <td class="text-align" v-text="item.cnt_sex['male'] === 0 ? '' : item.cnt_sex['male']"></td>
        <td class="text-align" v-text="item.cnt_sex['xmale'] === 0 ? '' : item.cnt_sex['xmale']"></td>
        <td class="table_line" v-text="item.cnt_sex['etc'] === 0 ? '' : item.cnt_sex['etc']"></td>

        <td>{{ item.cnt_sex['sum'] }}</td>

      </tr>
      <tr v-else class="mobile_tr">
        <td class="mb_table">
            <div class="date mt-2">
              <div class="flex-title"> 경락일자</div>
              <div  @click="$emit('detailInfo', item.date)">
                <v-icon size="24" color="white">
                  mdi-file-document
                </v-icon> 
                {{ item.date }}
              </div>
             
            </div>

            <div class="flex">
              <div class="flex-title">육질등급</div>

              <div class="flex">
                <div class="flex-content">
                  <div class="weight">1++</div>
                  <div> {{ addCommas(item.cnt_qgrade['1++'] ) }} 두 </div>
                </div>

                <div class="flex-content">
                  <div class="weight">1+</div>
                  <div> {{ addCommas(item.cnt_qgrade['1+'] ) }} 두 </div>
                </div>

                <div class="flex-content">
                  <div class="weight">1</div>
                  <div> {{ addCommas(item.cnt_qgrade['1'] ) }} 두 </div>
                </div>

                <div class="flex-content">
                  <div class="weight">2</div>
                  <div> {{ addCommas(item.cnt_qgrade['2'] ) }} 두 </div>
                </div>

                <div class="flex-content">
                  <div class="weight">3</div>
                  <div> {{ addCommas(item.cnt_qgrade['3'] ) }} 두 </div>
                </div>

              </div>
              
              <div class="line-table"></div>
            </div>

            <div class="flex">
              <div class="flex-title">육량등급</div>

              <div class="flex">
                <div class="flex-content">
                  <div class="weight">A</div>
                  <div> {{ addCommas(item.cnt_wgrade['A'] ) }} 두 </div>
                </div>

                <div class="flex-content">
                  <div class="weight">B</div>
                  <div> {{ addCommas(item.cnt_wgrade['B'] ) }} 두 </div>
                </div>

                <div class="flex-content">
                  <div class="weight">C</div>
                  <div> {{ addCommas(item.cnt_wgrade['C'] ) }} 두 </div>
                </div>

                <!-- <div class="flex-content">
                  <div class="weight">D</div>
                  <div> {{ addCommas(item.cnt_wgrade['D'] ) }} 두 </div>
                </div> -->

              </div>
              
              <div class="line-table"></div>
            </div>

            <div class="flex">
              <div class="flex-title">평균 도체중</div>

              <div class="flex">
                <div class="flex-content">
                  <div class="weight">등급</div>
                  <div> {{ item['kg+'].ave }} kg </div>
                </div>

                <div class="flex-content">
                  <div class="weight">등외</div>
                  <div> {{ item['kg-'].ave }} kg </div>
                  <!-- <div> {{ addCommas(item.cnt_wgrade['B'] ) }} 두 </div> -->
                </div>
              </div>
              
              <div class="line-table"></div>
            </div>

            <div class="flex">
              <div class="flex-title">성별</div>

              <div class="flex">
                <div class="flex-content">
                  <div class="weight">암</div>
                  <div> {{ item.cnt_sex['female'] }} 두 </div>
                </div>

                <div class="flex-content">
                  <div class="weight">수</div>
                  <div> {{ item.cnt_sex['male'] }} 두 </div>
                </div>

                <div class="flex-content">
                  <div class="weight">거세</div>
                  <div> {{ item.cnt_sex['xmale'] }} 두 </div>
                </div>

                <div class="flex-content">
                  <div class="weight">프리마틴</div>
                  <div> {{ item.cnt_sex['etc'] }} 두 </div>
                </div>
              </div>
              
              <div class="line-table"></div>
            </div>

            <div class="flex">
              <!-- <div class="flex-title">계</div> -->

              <div class="flex date mb-2">
                <div class="flex-content">
                  <div class="weight">계</div>
                  <div> {{ item.cnt_sex['sum'] }} 두 </div>
                </div>
              </div>
            </div>
          </td>
     
        </tr>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: "CustomTable",
  props: {
    headers: {
      type: Array,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    sortBy: {
      type: String,
      default: "date",
    },
    sortDesc: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isMobile: false,
      tablesortBy: this.sortBy,
      tablesortDesc: this.sortDesc,
    };
  },
  methods: {
    updateSortBy(value) {
      this.tablesortBy = value;
      this.$emit("update:sortBy", value); 
    },
    updateSortDesc(value) {
      this.tablesortDesc = value;
      this.$emit("update:sortDesc", value);
    },
    toggleSort(column) {
      if (this.tablesortBy === column) {
        this.tablesortDesc = !this.tablesortDesc; 
      } else {
        this.tablesortBy = column;
        this.tablesortDesc = false; 
      }

      this.$emit("update:sortBy", this.tablesortBy);
      this.$emit("update:sortDesc", this.tablesortDesc);
    },

    addCommas(num) {
      if (typeof num === "number") {
        return num.toLocaleString();
      }
      return num;
    },
    onResize() {
      this.isMobile = window.innerWidth < 769;
    },

  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
};
</script>

<style scoped lang="scss">
@import '../../../style/table_mb.scss';
.table_line{
  border-right:1px solid #cfcfcf !important;
  text-align: center;
}
*{
  text-align: center !important;
}
.detail{
  cursor: pointer;
}
.text-align{
  text-align: center;
}
.v-data-table th {
  text-align: center !important;
  vertical-align: middle !important;
}
.v-table td {
  text-align: center;
  vertical-align: middle;
}
</style>
